import { combineReducers } from 'redux';
import { merge } from 'lodash'
import { normalize, schema } from 'normalizr';

// Define a ledgermaps schema
const ledgermapSchema = new schema.Entity('ledgermaps',{}, { idAttribute: 'id' });
const ledgermapListSchema = [ledgermapSchema];

const defaultLedgermapParams = {
  ledgermapFetched: false,
  searchFetched: false,
  isDelFetched: false,
  createTitle: 'Create New Ledgermap',
  createSubmitButtonText: 'Create Ledgermap',
  editTitle: 'Edit Ledgermap',
  editSubmitButtonText: 'Edit Ledgermap',
  cloneTitle: 'Clone Ledgermap',
  cloneSubmitButtonText: 'Clone Ledgermap'
}


function byId(state = {}, action) {
    if (action.type === 'SAVED_LEDGERMAP') {
        const ledgermapID = action.payload.id;
      return {...state, 
        [ledgermapID]: action.payload
      }
    }
    if (action.type === 'FETCHED_LEDGERMAP') { 
        const normalizedLedgermap = normalize(action.payload, ledgermapListSchema);
        return merge({},state,normalizedLedgermap.entities.ledgermaps)
    }     
    if (action.type === 'DELETED_LEDGERMAP') {
      if(action.payload.msg === "Success"){
        const ledgermapID = action.payload.id;
        return {...state, 
          [ledgermapID]: { ...state[ledgermapID],
            status :0
          }
        }
      }  else {
        return state
      }
    } 
    if (action.type === 'RESET_DATA') { 
      return {}
    } else {
      return state
    }
  }

function searchResults(state = {}, action) {
  if (action.type === 'STORE_SEARCH_LEDGERMAP_RESULT') { 
    const normalizedLedgermap = normalize(action.payload, ledgermapListSchema);
    return merge({},normalizedLedgermap.entities.ledgermaps)
} else {
    return state
  }
}

function filterResults(state = {}, action) {
  if (action.type === 'FILTER_ITEMS') { 
      const col = action.payload.col;
      return {...state,
        [col]: action.payload
      }
  } else {
    return state
  }
}

function notifications ( state = {}, action ) {
  if (action.type === 'SAVED_LEDGERMAP') {

    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        save: {
          status: (action.txn === "success" || action.txn === "Success") ? 'success' : 'error',
          msg: action.msg || action.txn
        }
      }
    }
  }
  if (action.type === 'DELETED_LEDGERMAP') {
    return {...state, 
      [action.payload.id]: { ...state[action.payload.id],
        delete: { 
          status : action.payload.msg === "Success" ? 'success' : 'error',
          msg : action.payload.msg
        }
      }
    }
  } 
  if(action.type === 'NOTIFICATION_DONE_LEDGERMAP'){
    const {id, type} = action.payload
    // Remove the 'id' element from state
    const { [id]: idValue, ...restOfState } = state;
    // Remove the 'type' from the 'id' element
    const { [type]: removedValue, ...restOfId } = idValue;
    // Merge back together
    const finalState = { ...restOfState, [id]: restOfId };     
    return finalState

  } else {
    return state
  }
}


function params(state = defaultLedgermapParams, action) {
  if (action.type === 'FETCHED_LEDGERMAP') { 
      return {...state, 
        ledgermapFetched: true,
        isFetching:false
      }
  }   if (action.type === 'SEARCH_LEDGERMAP') { 
    return {...state, 
      searchFetched: false,
      isSearching: true,
    }
  } 
  if (action.type === 'STORE_SEARCH_LEDGERMAP_RESULT') { 
    return {...state, 
      searchFetched: true,
      isSearching : false,
    }
  } 
  if (action.type === 'DELETED_LEDGERMAP') { 
    return {...state, 
      isDelFetched:true
    }
  }if(action.type === 'SET_LEDGERMAP_FETCH_OFF'){
    return {...state, 
      isDelFetched:false
    }
  } 
  if (action.type === 'RESET_DATA') { 
    return defaultLedgermapParams
  } else {
    return state
  }
}

const ledgermap = combineReducers({
    byId,
    notifications,
    searchResults,
    params,
    filterResults
});

export default ledgermap;

